/* eslint-disable react/prop-types */
import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Icon from '@ff/ui/Icon';
import url from 'client/utils/url';
import useConfig from 'client/hooks/useConfig';
import { useHistory } from 'react-router-dom';
import { H3 } from 'client/v3/typography';
import appHandlers from 'client/utils/appHandlers';

export default function H5HeaderLayout({ children }) {
  const history = useHistory();
  const qs = useConfig();

  const entryPage = qs.ENTRY_PAGE;
  // If entry page is null in url, that means current page is the entry page.
  if(!entryPage){
    const { location } = window;
    const currentPage = url.getCurrentPageV3();

    // add entry page into url
    history.replace(`${location.search}&ENTRY_PAGE=${currentPage}`);
    return null;
  }

  const handleCloseClick = appHandlers.getHandlerByKey('CloseConfigurator')
  const handleBackClick = () => {
    const path = url.getPageBackNavigationV3(qs);
    if(path){
      history.replace(path);
    }
    else{
      setTimeout(appHandlers.getHandlerByKey('CloseConfigurator'), 10);
    }
  }

  return (
    <>
      <Container>
        <Box flex='1' display='flex'>
          <BackIcon name='ff-icon-arrow_back_ios' fontSize='22px' onClick={handleBackClick} />
          <Box display='flex' flex='1' justifyContent='center'>
            <CloseIcon name='ff-icon-clear' fontSize='28px' onClick={handleCloseClick} />
          </Box>
        </Box>
        <H3 width='180px' height='30px' textAlign='center'>Configure My FF 91</H3>
        <Box flex='1'></Box>
      </Container>
      <main>
        <Box
          height='50px'
          backgroundColor='rgba(249, 249, 249, 1)'
        ></Box>
        {children}
      </main>
    </>
  );
}

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'fixed',
  top: '0px',
  left: '0px',
  height: '50px',
  display: 'flex',
  alignItems: 'flex-end',
  paddingBottom: '10px',
  color: theme.colors.text01,
  backgroundColor: theme.colors.bg01,
  paddingLeft: '12px',
  paddingRight: '12px',
  zIndex: 999,
}));

const BackIcon = styled(Icon)({
  display: 'block',
  lineHeight: '30px',
  height: '30px',
});

const CloseIcon = styled(Icon)({
  display: 'block',
  lineHeight: '30px',
  height: '30px',
});
